module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-gray-back"
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "row-list",
      on: {
        "click": function($event) {
          return _vm.onItemChange(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "sale-box",
      style: (_vm.check_index == index ? 'border:1px solid #ccc' : '')
    }, [_c('div', [_c('div', {
      staticClass: "cell-t flex-start"
    }, [_c('span', {
      staticStyle: {
        "min-width": "1.4rem"
      }
    }, [_vm._v("购买人:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "0.1rem"
      }
    }, [_vm._v(_vm._s(item.user_name))])]), _vm._v(" "), _c('div', {
      staticClass: "cell-t flex-start"
    }, [_c('span', {
      staticStyle: {
        "min-width": "1.4rem"
      }
    }, [_vm._v("收件人:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "0.1rem"
      }
    }, [_vm._v(_vm._s(item.express_user_name))])]), _vm._v(" "), _c('div', {
      staticClass: "cell-t flex-start"
    }, [_c('span', {
      staticStyle: {
        "min-width": "1.4rem"
      }
    }, [_vm._v("手机号:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "0.1rem"
      }
    }, [_vm._v(_vm._s(item.express_user_phone))])]), _vm._v(" "), _c('div', {
      staticClass: "cell-t flex-start"
    }, [_c('span', {
      staticStyle: {
        "min-width": "1.4rem"
      }
    }, [_vm._v("收获地址:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "0.1rem"
      }
    }, [_vm._v(_vm._s(item.express_address))])]), _vm._v(" "), _c('div', {
      staticClass: "cell-t flex-start"
    }, [_c('span', {
      staticStyle: {
        "min-width": "1.4rem"
      }
    }, [_vm._v("订单状态:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "0.1rem"
      }
    }, [_vm._v(_vm._s(item.order_status.name))])]), _vm._v(" "), _vm._l((item.items), function(order, o) {
      return _c('div', {
        key: o,
        staticClass: "flex-start goods_item_b"
      }, [_c('img', {
        staticStyle: {
          "width": "1.5rem",
          "height": "1.5rem",
          "min-width": "1.5rem",
          "margin-right": "0.2rem"
        },
        attrs: {
          "src": order.pic_url,
          "alt": "",
          "srcset": ""
        }
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "height": "1.5rem",
          "flex": "1"
        }
      }, [_c('div', {
        staticClass: "show-two-row"
      }, [_vm._v(_vm._s(order.title))]), _vm._v(" "), _c('div', {
        staticClass: "show-two-row",
        staticStyle: {
          "color": "red"
        }
      }, [_vm._v("\n                  " + _vm._s(order.goods_price) + "\n                ")]), _vm._v(" "), _c('div', {
        staticClass: "flex-between"
      }, [_c('div', {
        staticClass: "show-one-row",
        staticStyle: {
          "width": "4rem"
        }
      }, [_vm._v("\n                    " + _vm._s(order.sku.sku_formart) + "\n                  ")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "width": "0.8rem",
          "min-width": "0.8rem",
          "text-align": "right"
        }
      }, [_vm._v("\n                    x" + _vm._s(order.count) + "\n                  ")])])])])
    })], 2)])])
  }), 0)], 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.actions
    },
    on: {
      "closed": _vm.onClose,
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a1e828c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/configure/SaleOrderList.vue
// module id = 2294
// module chunks = 0